import React, { useCallback, useEffect, useRef } from 'react';
import { Container } from '@fiverr-private/layout_components';
import BookingSection from '../sections/BookingSection';
import CinematicSection from '../sections/CinematicSection';
import DirectorsSection from '../sections/DirectorsSection';
import FooterSection from '../sections/FooterSection';
import HeaderSection from '../sections/HeaderSection';
import HeroSection from '../sections/HeroSection';
import PartnerRevealSection from '../sections/PartnerRevealSection';
import useSmoothScroll from '../hooks/useSmoothScroll';
import { MIXPANEL_EVENTS, sendMixpanelEvent } from '../shared/tracking';
import { pageRoot } from './styles.ve.css';

const HollywoodPage: React.FC = () => {
  const bookingSectionRef = useRef<HTMLDivElement>(null);
  const directorsSectionRef = useRef<HTMLDivElement>(null);
  const { scrollTo } = useSmoothScroll();

  useEffect(() => {
    sendMixpanelEvent({ eventName: MIXPANEL_EVENTS.PAGE_VIEW });
  }, []);

  const scrollToBooking = useCallback(() => {
    const target = bookingSectionRef.current;

    if (!target) {
      return;
    }

    scrollTo(target);
  }, [scrollTo]);

  const scrollToDirectors = useCallback(() => {
    const target = directorsSectionRef.current;

    if (!target) {
      return;
    }

    scrollTo(target, { offset: -50 });
  }, [scrollTo]);

  return (
    <Container className={pageRoot}>
      <Container position="relative">
        <HeaderSection onPrimaryCtaClick={scrollToBooking} />
        <HeroSection onExploreClick={scrollToDirectors} />
      </Container>
      <PartnerRevealSection />
      <Container ref={directorsSectionRef}>
        <DirectorsSection onStartProjectClick={scrollToBooking} scrollTo={scrollTo} />
      </Container>
      <CinematicSection onPrimaryCtaClick={scrollToBooking} />
      {/* <CampaignSection /> */}
      <BookingSection ref={bookingSectionRef} />
      <FooterSection />
    </Container>
  );
};

export default HollywoodPage;
